module.exports = __webpack_public_path__ + "img/conclusion2.86631171.png";